exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".module-config-table[data-v-3bb4daba]{overflow:unset}", ""]);

// exports
